import React, { useEffect, useState, useCallback } from "react";
import Banner from "../Banner/Banner";
import "./banners.css";
import { Link } from "react-router-dom";
import { useUserLogout } from "../../hooks/useUserQueries";

export default function Banners({ data, loading }) {
  const [step, setStep] = useState(0);
  const [item, setItem] = useState(null);
  const [hide, setHide] = useState(false);
  const logoutMutation = useUserLogout();

  useEffect(() => {
    setItem(null);

    const timer = setTimeout(() => {
      const currentItem = data?.[step];
      if (currentItem) {
        setItem(currentItem);
      }
    }, 2);

    return () => clearTimeout(timer);
  }, [step, data]);

  const changeStep = useCallback(
    (direction = "next") => {
      setStep((prevStep) => {
        const totalSteps = data?.length || 0;
        let newStep = direction === "next" ? prevStep + 1 : prevStep - 1;

        if (newStep < 0) {
          newStep = totalSteps - 1;
        }

        if (newStep >= totalSteps) {
          newStep = 0;
        }
        return newStep;
      });
    },
    [data]
  );

  const onFullScreen = () => {
    const { ipcRenderer } = window.require("electron");
    setHide(!hide);
    ipcRenderer.send("fullscreen-window");
  };

  const onHideFullScreen = () => {
    const { ipcRenderer } = window.require("electron");
    setHide(!hide);
    ipcRenderer.send("hide-fullscreen-window");
  };

  return (
    <div className="home_publish">
      <div className="home_publish-item">
        <button
          onClick={() => logoutMutation.mutate()}
          className="button-banner button-logout"
        />
        <button
          onClick={!hide ? onFullScreen : onHideFullScreen}
          className="button-banner button-full-width"
        />
        {item && <Banner {...item} changeStep={changeStep} />}
        <Link className="continue_btn" to={"/peliculas"}>
          Continuar
        </Link>
      </div>
    </div>
  );
}
